module.exports = __webpack_public_path__ + "img/logo-light.22fcda1b.svg";